<template>
  <div
    v-if="recentlyViewedProducts.length > 0"
    class="recently-viewed-products critical-component-clear"
  >
    <product-card-carousel
      :carousel-data="recentlyViewedProducts"
      :page-type="pageType"
      :title="title"
    />
  </div>
</template>

<script>

/**
 * Vue: Recently viewed products (recently-viewed-products)
 * -----------------------------------------------------------------------------
 * Displays the user's most recently viewed products.
 *
 * @param {Number} maxProducts - Maximum number of products this section can
 * display. Defaults to 8.
 * @param {String} pageType - Shopify request page_type response.
 * @param {String} title - Section title.
 *
 */
import { formatProduct } from '~/format/format-product'
import productQuery from '~graphql/product.gql'

import ProductCardCarousel from '~async/product-card-carousel/product-card-carousel'

export default {
  name: 'RecentlyViewedProducts',

  components: {
    ProductCardCarousel,
  },

  props: {
    currentProductHandle: {
      type: String,
      default: '',
    },
    maxProducts: {
      type: Number,
      default: 8,
    },
    pageType: {
      type: String,
      default: 'index',
    },
    title: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      recentlyViewedProducts: [],
    }
  },

  mounted() {
    this.setRecentlyViewedProducts()
  },

  methods: {

    /**
     * Set recently viewed products array.
     */
    async setRecentlyViewedProducts() {
      const storedProductsKey = 'recently-viewed-products'
      let storedProducts = sessionStorage.getItem(storedProductsKey)

      if (!storedProducts) {
        return
      }

      storedProducts = JSON.parse(sessionStorage.getItem(storedProductsKey))
        .filter(handle => handle !== this.currentProductHandle)
        .toReversed().slice(0, this.maxProducts)

      this.recentlyViewedProducts = await Promise.all(
        storedProducts.map(async(productHandle) => {
          const formattedProduct = await this.queryProduct(productHandle)
          return formattedProduct
        }),
      )
    },

    /**
     * Loads product from GraphQL.
     * @param {String} [handle] - Product handle to load.
     * @returns {Boolean|Object}
     */
    async queryProduct(handle) {
      if (handle === false) {
        return false
      }

      try {
        const response = await cnvs.Query({
          query: productQuery,
          variables: {
            country: this.$variable('store.country'),
            handle,
            language: this.$variable('store.language'),
          },
        })

        return formatProduct(response)

      } catch (error) {
        cnvs.ReportError('Failed to load product', error)
        return false
      }
    },
  },
}
</script>

<style lang="scss">
@import './recently-viewed-products';
</style>
